import { API, setAuthToken } from '../../../config/API.js';
import { GET_KOTA, SET_LOADING_KOTA, SET_PAGINATION_KOTA } from '../constant.js';

export const getKota = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_KOTA,
      payload: true,
    });
    API.get(`admin/city?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_KOTA,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_KOTA,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_KOTA,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_KOTA,
          payload: 0,
        });
      });
  };
};

export const addKota = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/city/add", params);
};

export const getDetailKota = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/city/${code}`);
};

export const updKota = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/city/edit", params);
};

export const delKota = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/city/delete/" + code);
};
